export default __webpack_public_path__ + "static/media/map-pin-orange.b194d1d8.svg";